import cx from 'classnames';

import s from './EllipseOutline.module.css';

export interface EllipseOutlineProps {
  className?: string;
}

const EllipseOutline = ({ className }: EllipseOutlineProps) => {
  return <div className={cx(s.root, className)} />;
};

export { EllipseOutline };
